import "../../styles/global.less";
import "../../styles/reset.less";
import "./equity-solution.less";

let fsTableList;
let menuItemBoxs;
let sectionAnliDoms;

let menuItemsInitTop;

// 1400展示
// 1467 + 217
// 1684

import $ from "jquery";
$(document).ready(function () {
  const currentFsIndex = 0;
  fsTableList = $(".fs-table-wrapper");
  menuItemBoxs = $(".menu-item-box");
  sectionAnliDoms = $(".section-anli");

  // 获取menuItemsInitTop距离顶部的距离
  menuItemsInitTop = $(".hzfs").offset().top;

  const scrollTop = window.scrollY || window.pageYOffset;
  handleResetMenuList(scrollTop);

  fsTableList.each((index, item) => {
    $(item).hide();
  });

  sectionAnliDoms.each((index, item) => {
    $(item).hide();
  });

  showFsTable(currentFsIndex);

  menuItemBoxs.each((index, item) => {
    $(item).click(() => {
      window.scrollTo({
        top: menuItemsInitTop - 117,
        behavior: "smooth", // 可选，平滑滚动效果
      });
      showFsTable(index);
    });
  });

  // 监听滚动条
  $(window).scroll(() => {
    const scrollPosition = $(window).scrollTop();
    console.log("当前滚动位置: " + scrollPosition);
    const scrollTop = window.scrollY || window.pageYOffset;
    handleResetMenuList(scrollTop);
  });
});

function handleResetMenuList(scrollTop) {
  // 判断是否显示
  if (scrollTop < menuItemsInitTop - 217) {
    menuItemBoxs.hide();
    $(".menu-list li").hide();
  } else {
    // 显示、判断距离
    menuItemBoxs.show();
    $(".menu-list li").show();
  }
}

window.showFsTable = (index) => {
  fsTableList.each((index, item) => {
    $(item).hide();
  });
  $(fsTableList[index]).show();

  menuItemBoxs.each((i, item) => {
    $(item).parent().removeClass("active");
    if (i === index) {
      $(item).parent().addClass("active");
    }
  });

  sectionAnliDoms.each((i, item) => {
    $(item).hide();
    if (i === index) {
      $(item).show();
    }
  });
};
